import { Splide } from '@splidejs/splide';
import '@splidejs/splide/css/core';

class OfficeTourSlides {
  constructor(el) {
    this.dom = {el: el};
    this.dom.imageSlider = this.dom.el.querySelector('[data-js="office-tour-slide"]');
    this.dom.textSlider = this.dom.el.querySelector('[data-js="office-tour-text-slide"]');

    this.dom.slides = this.dom.textSlider.querySelectorAll('.splide__slide');

    this.dom.arrowPrev = this.dom.el.querySelector('.splide__arrow--prev');
    this.dom.arrowNext = this.dom.el.querySelector('.splide__arrow--next');

    this.dom.progress = this.dom.el.querySelector('[data-js="progress"]');
    this.dom.progressCurrent = this.dom.el.querySelector('[data-js="progress-current"]');
    this.dom.progressTotal = this.dom.el.querySelector('[data-js="progress-total"]');

    this.mql = window.matchMedia('screen and (min-width: 768px)');
    this.checkBreakPoint = this.checkBreakPoint.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);

    this.slidesLength = (this.dom.slides.length < 10) ? `0${this.dom.slides.length}` : this.dom.slides.length;

    this.imageSlider = null;
    this.textSlider = null;

    this.imageOption = {
      // autoplay: true,
      autoWidth: true,
      focus: 'center',
      type: 'loop',
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 5000,
      speed: 2000,
      arrows: false,
      // arrowPath: 'M20.4244 33.5403C20.9182 33.8699 21.4987 34.0456 22.0924 34.0451C22.4873 34.0461 22.8785 33.969 23.2436 33.8185C23.6087 33.6679 23.9404 33.4467 24.2199 33.1676L35.2674 22.1201C35.5471 21.8414 35.769 21.5102 35.9204 21.1455C36.0718 20.7809 36.1497 20.3899 36.1497 19.9951C36.1497 19.6002 36.0718 19.2093 35.9204 18.8446C35.769 18.48 35.5471 18.1488 35.2674 17.8701L24.2199 6.82259C23.6563 6.259 22.8919 5.94238 22.0949 5.94238C21.2978 5.94238 20.5334 6.259 19.9699 6.82259C19.4063 7.38617 19.0897 8.15056 19.0897 8.94759C19.0897 9.74462 19.4063 10.509 19.9699 11.0726L25.8974 17.0001H5.00012C4.20447 17.0001 3.44141 17.3162 2.8788 17.8788C2.31619 18.4414 2.00012 19.2045 2.00012 20.0001C2.00012 20.7958 2.31619 21.5588 2.8788 22.1214C3.44141 22.6841 4.20447 23.0001 5.00012 23.0001H25.8923L19.9699 28.9226C19.5498 29.3422 19.2637 29.8769 19.1478 30.4592C19.0318 31.0414 19.0912 31.645 19.3185 32.1935C19.5458 32.7419 19.9306 33.2106 20.4244 33.5403Z',
      pagination: false,
      gap: `${20 / 375 * 100}%`,
      mediaQuery: 'min',
      breakpoints: {
        768: {
          focus: 0,
          gap: `${36 / 1440 * 100}vw`,
        },
      }
    };
    this.textOption = {
      // autoplay: true,
      type: 'fade',
      rewind: true,
      pauseOnHover: false,
      pauseOnFocus: false,
      interval: 5000,
      speed: 2000,
      drag: false,
      arrows: false,
      pagination: false,
      // padding: `${160 / 1440 * 100}%`,
    };

    this.init();
  }

  init() {

    this.imageSlider = new Splide(this.dom.imageSlider, this.imageOption);
    this.textSlider = new Splide(this.dom.textSlider, this.textOption);

    this.imageSlider.on('mounted', ()=>{
      this.mountedEvent();
    });
    this.imageSlider.on('move', (newIndex, oldIndex, destIndex)=>{
      this.moveEvent(newIndex + 1);
    });
    // this.imageSlider.on('moved', (newIndex, oldIndex, destIndex)=>{
    //   this.movedEvent();
    // });

    this.imageSlider.sync(this.textSlider);
    this.imageSlider.mount();
    this.textSlider.mount();

    this.dom.arrowPrev.addEventListener('click', this.prevSlide);
    this.dom.arrowNext.addEventListener('click', this.nextSlide);
    // // ブレイクポイントの瞬間に発火
    // this.mql.addListener(this.checkBreakPoint);
    // // 初回チェック
    // this.checkBreakPoint(this.mql);
  }

  prevSlide() {
    this.imageSlider.go('<');
  }

  nextSlide() {
    this.imageSlider.go('>');
  }

  mountedEvent() {
    this.dom.progressCurrent.textContent = '01';
    this.dom.progressTotal.textContent = this.slidesLength;
  }

  moveEvent(_index) {
    this.dom.progressCurrent.textContent = (_index < 10) ? `0${_index}` : _index;
  }

  checkBreakPoint(_mql) {
		if (!_mql.matches) {
      // console.log('sp');

      if (this.slider) this.slider.destroy();
      this.slider = new Splide(this.dom.imageSlider, this.imageOption);
      this.slider.mount();

      return;
    } else {
      // console.log('pc');

      this.progressScale();

      if (this.slider) this.slider.destroy();
      this.slider = new Splide(this.dom.imageSlider, this.textOption);
      this.slider.mount();

      return;
		}
	}
}

export default OfficeTourSlides